import type { NextPage } from 'next'
import Head from 'next/head'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'

// Libs
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

// Components
import SearchComponent from '@/components/pages/Search'
import LiveMallClubSearchComponent from '@/components/pages/livemallclub/Search'

// Constants
import { envConfigs } from '@/constants/config'
import { ROUTE_PATH } from '@/constants/routePath'
import { DEFAULT_LOCALE } from '@/constants/defaultLocale'
import { isLiveMallClub } from '@/constants/systemType'

// Styles

// Variables
const Search: NextPage = () => {
  const router = useRouter()
  const { t } = useTranslation()
  const { query } = router
  const { keyword } = query

  const currentLocale = router.locale === 'default' ? DEFAULT_LOCALE : router.locale
  const title = keyword
    ? `#${keyword} | ${t('Meta_Title_Search_Keyword', { brandName: 'TutorABC Shop' })}`
    : t('Meta_Title_Fast_Search', { brandName: 'TutorABC Shop' })
  const description = keyword
    ? `#${keyword} | ${t('Meta_Title_Search_Keyword', { brandName: 'TutorABC Shop' })}`
    : t('Meta_Description_Search', { brandName: 'TutorABC Shop' })

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='title' key='meta-title' content={title} />
        <meta name='description' key='meta-description' content={description} />
        <link rel='canonical' href={`${envConfigs.domainUrl}/${currentLocale}${ROUTE_PATH.SEARCH}?keyword=${keyword || ''}`} />
      </Head>
      {isLiveMallClub ? <LiveMallClubSearchComponent /> : <SearchComponent />}
    </>
  )
}
export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, ['common'])),
    },
  }
}
export default Search
